import { ApolloQueryResult, OperationVariables } from '@apollo/client'
import { Pagination } from '@material-ui/lab'
import React from 'react'

import NoDataImage from '../../assets/images/No-Data.png'
import {
  AllocationLog,
  AllocationLogsData
} from '../../types/inventoryAllocationLogs'
import { AllocationHistoryTableHeader } from './AllocationHistoryTableHeader'
import { AllocationHistoryTableRow } from './AllocationHistoryTableRow'
import { AllocationHistoryRowSkeleton } from './AllocationHistoryTableRow.skeleton'
import useStyles from './styles/AllocationHistoryTable.styles'

interface AllocationHistoryTableProps {
  data: AllocationLog[]
  loadingForGetBookingList: boolean
  page: number
  setPage(page: number): void
  totalCount: number
  perPage: number
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      allocationLogs: AllocationLogsData
    }>
  >
}
export const AllocationHistoryTable: React.FC<AllocationHistoryTableProps> = ({
  data,
  loadingForGetBookingList,
  page,
  setPage,
  refetch,
  totalCount,
  perPage
}) => {
  const classes = useStyles()
  return (
    <div>
      <AllocationHistoryTableHeader setPage={setPage} refetch={refetch} />
      {loadingForGetBookingList ? (
        Array(8)
          .fill('')
          .map((_, skeletonIndex) => (
            <AllocationHistoryRowSkeleton key={skeletonIndex} />
          ))
      ) : data && data.length > 0 ? (
        data?.map((item, index) => (
          <AllocationHistoryTableRow key={index} data={item} />
        ))
      ) : (
        <div className={classes.noDataImageContainer}>
          <img src={NoDataImage} alt="no_booking_list" />
        </div>
      )}
      <div className={classes.paginationContainer}>
        <Pagination
          count={Math.ceil(totalCount / perPage)}
          color="primary"
          page={page}
          onChange={(_, value) => setPage(value)}
        />
      </div>
    </div>
  )
}
